import React, { Component, Fragment } from 'react';

export default class Settings extends Component {

	constructor(props) {
    super(props);
		this.inputChange = this.inputChange.bind(this);
    this.state = {
			autoload: this.props.settings.autoload,
			autorefresh: this.props.settings.autorefresh
		};
  }

	render() {
		console.log('settings', this.state, this.props);
		return (
			<Fragment>
      	<h1>Settings</h1>
				<h2>Post loading</h2>
				<form action="/settings" method="post">
					<ul>
						<li><label><input type="checkbox" name="autorefresh" onChange={ this.inputChange } checked={ this.state.autorefresh === true ? 'checked' : false } /> Auto refresh</label></li>
						<li><label><input type="checkbox" name="autoload" onChange={ this.inputChange } checked={ this.state.autoload === true ? 'checked' : false } /> Auto load</label></li>
					</ul>
				</form>
			</Fragment>
		);
  }

	inputChange(e) {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		console.log(name, value);
		this.setState({
			[name]: value
		}, () => this.props.onSetChange(this.state));
	}
}



// WEBPACK FOOTER //
// ./src/components/settings.jsx